import { render, staticRenderFns } from "./HelpFiles.vue?vue&type=template&id=e3ea85ca"
import script from "./HelpFiles.vue?vue&type=script&lang=js"
export * from "./HelpFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports